module.exports = __webpack_public_path__ + "img/seigniorage-border.1d06ff40.svg";